import { useState } from "react";
import { format } from "date-fns";
import { XIcon, PencilAltIcon } from "@heroicons/react/outline";
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/solid";
import Modal from "@material-ui/core/Modal";
import { RequestForm } from "../Forms/RequestForm";
import CurrencyDisplay from "../Currency/CurrencyDisplay";

export const RequestCard = ({ data, getPaymentsRequest }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const isDeposit = data.type === "Deposite" || data.type === "Deposit";

  // Status Badge Logic
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "bg-green-100 text-green-700";
      case "declined":
        return "bg-red-100 text-red-700";
      default:
        return "bg-yellow-100 text-yellow-700";
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        className="flex items-center justify-center p-4 backdrop-blur-sm"
      >
        <div className="bg-white rounded-3xl w-full max-w-xl shadow-2xl outline-none relative overflow-hidden max-h-[90vh] overflow-y-auto">
          {/* Modal Header */}
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-100 flex justify-between items-center sticky top-0 z-10">
            <h3 className="font-heading font-bold text-lg text-gray-800">
              Review Request
            </h3>
            <button
              onClick={handleClose}
              className="p-1 rounded-full hover:bg-gray-200 transition-colors text-gray-500"
            >
              <XIcon className="w-6 h-6" />
            </button>
          </div>

          <div className="p-6">
            <RequestForm
              handleClose={handleClose}
              data={data}
              getPaymentsRequest={getPaymentsRequest}
            />
          </div>
        </div>
      </Modal>

      {/* --- THE CARD --- */}
      <div className="group bg-white rounded-2xl shadow-sm hover:shadow-md border border-gray-100 p-5 transition-all duration-300 relative overflow-hidden flex items-center justify-between gap-4">
        {/* Left: Icon & Details */}
        <div className="flex items-center gap-4">
          <div
            className={`w-12 h-12 rounded-xl flex items-center justify-center text-xl shrink-0 ${
              isDeposit
                ? "bg-green-50 text-green-600"
                : "bg-red-50 text-red-600"
            }`}
          >
            {isDeposit ? (
              <ArrowDownIcon className="w-6 h-6" />
            ) : (
              <ArrowUpIcon className="w-6 h-6" />
            )}
          </div>

          <div>
            <div className="flex items-center gap-2 mb-1">
              <h3 className="font-heading font-bold text-gray-900 text-base">
                {isDeposit ? "Deposit Request" : "Withdrawal Request"}
              </h3>
              <span
                className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded-full ${getStatusColor(
                  data.status,
                )}`}
              >
                {data.status || "Pending"}
              </span>
            </div>

            <p className="text-xs text-gray-500 font-body">
              {data.createdAt
                ? format(new Date(data.createdAt), "MMM dd, yyyy • h:mm a")
                : "Date Unknown"}
            </p>
          </div>
        </div>

        {/* Right: Amount & Edit */}
        <div className="text-right flex items-center gap-6">
          <div className="hidden sm:block">
            <p className="text-xs text-gray-400 font-bold uppercase">Amount</p>
            <p
              className={`text-lg font-bold ${
                isDeposit ? "text-green-600" : "text-gray-900"
              }`}
            >
              {isDeposit ? "+" : "-"}
              <CurrencyDisplay usdAmount={data?.amount} className="inline" />
            </p>
          </div>

          <button
            onClick={handleOpen}
            className="p-2 rounded-full hover:bg-gray-100 text-gray-400 hover:text-primary transition-colors"
          >
            <PencilAltIcon className="w-5 h-5" />
          </button>
        </div>
      </div>
    </>
  );
};
